export default __webpack_public_path__ + "static/media/VUT.bc4285f7.svg";